export const selectPeriodData = [
  {
    label: 'Somente preços dos últimos 7 dias',
    value: 7,
  },
  {
    label: 'Somente preços dos últimos 30 dias',
    value: 30,
  },
  {
    label: 'Somente preços dos últimos 90 dias',
    value: 90,
  },
];

export const PRODUCT_COVERAGE_CHART_DATA = {
  category: {
    title: 'Cobertura de produtos por categoria',
    subtitle: null,
    filterLabel: 'Categoria',
    xAxisTitle: 'CATEGORIAS',
    selectedPlaceholder: 'Categorias',
    placeholder: 'Todas as categorias filtradas',
    searchFilter: false,
  },
  city: {
    title: 'Cobertura de produtos por cidade',
    subtitle: null,
    filterLabel: 'Cidades',
    xAxisTitle: 'CIDADES',
    placeholder: 'Pesquise por uma cidade',
    selectedPlaceholder: '',
    searchFilter: true,
  },
  uf: {
    title: 'Cobertura de produtos por UF',
    subtitle: null,
    filterLabel: 'UF',
    xAxisTitle: 'UF’S',
    placeholder: 'Todas as UF’s filtradas',
    selectedPlaceholder: 'UF’s',
    searchFilter: false,
  },
  section: {
    title: 'Cobertura de produtos por seção',
    subtitle: null,
    filterLabel: 'Seções',
    xAxisTitle: 'SEÇÕES',
    placeholder: 'Todas as seções filtradas',
    selectedPlaceholder: 'Seções',
    searchFilter: false,
  },
  chain: {
    title: 'Cobertura de produtos por rede',
    subtitle: 'Confira a cobertura do Infopanel para os seus produtos rede a rede',
    filterLabel: 'Redes',
    xAxisTitle: 'REDES',
    placeholder: 'Todas as redes filtradas',
    selectedPlaceholder: 'Redes',
    searchFilter: true,
  },
};

export const COVERAGE_PRODUCT_TYPE = {
  categoria: 'category',
  cidade: 'city',
  uf: 'uf',
  secao: 'section',
  rede: 'chain',
};

export const COVERAGE_PRODUCT_TYPE_KEY = {
  category: 'categoria',
  city: 'cidade',
  uf: 'uf',
  section: 'secao',
  chain: 'rede',
};
